import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { Response, URLSearchParams } from '@angular/http'

import { BaseModelService } from './base-model.service'
import { Session } from './session.model'
import { SessionSerializer, SessionInterviewerFinishSerializer } from 'serializers'

@Injectable()
export class SessionService extends BaseModelService<Session> {
  constructor() {
    super()

    this.configure({
      basePath:  'sessions',
      key:       'session',
      pluralKey: 'sessions',
      serializer: SessionSerializer
    })
  }

  updateAccessorComment(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'accessor_comment')
    return this.patch(url, obj)
  }

  updateModeratorComment(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'moderator_comment')
    return this.patch(url, obj)
  }

  updateAccessorImages(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'update_accessor_images')
    return this.patch(url, obj)
  }

  updateAdditionalImages(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'update_additional_images')
    return this.patch(url, obj)
  }

  accessorAssign(): Observable<Object> {
    let url = this.buildUrl('accessor_assign')
    return this.patch(url)
  }

  moderatorAssign(): Observable<Object> {
    let url = this.buildUrl('moderator_assign')
    return this.patch(url)
  }

  accessorStart(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'accessor_start')
    return this.patch(url)
  }

  assessorComplete(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'accessor_complete')
    return this.patch(url, obj)
  }

  moderatorStart(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'moderator_start')
    return this.patch(url)
  }

  moderatorComplete(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'moderator_complete')
    return this.patch(url, obj)
  }

  adminComplete(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'admin_complete')
    return this.patch(url, obj)
  }

  updateVideoaccessorComment(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'update_videoaccessor_comment')
    return this.patch(url, obj)
  }

  updateVideoaccessorImages(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'update_videoaccessor_images')
    return this.patch(url, obj)
  }

  videoassessorApprove(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'videoaccessor_approve')
    return this.patch(url, obj)
  }

  videoassessorReject(obj: Session|Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'videoaccessor_reject')
    return this.patch(url, obj)
  }

  videoaccessorWarning(obj: Object): Observable<Object> {
    let url = this.buildUrl(obj['id'], 'videoaccessor_warning')
    return this.patch(url, obj)
  }

  videoaccessorInactivate(obj: Session|Object) {
    let url = this.buildUrl(obj['id'], 'videoaccessor_inactivate')
    return this.patch(url, obj)
  }

  // interviewerApprove(obj: Session, onlyBusiness:boolean): Observable<Object> {
  //   let url = this.buildUrl(obj['id'], 'interviewer_approve')
  //   obj = Object.assign(obj)
  //   return this.patch(url, obj, {
  //     onlyBusiness: onlyBusiness
  //   })
  // }

  // interviewerReject(obj: Session): Observable<Object> {
  //   let url = this.buildUrl(obj['id'], 'interviewer_reject')
  //   return this.patch(url, obj)
  // }

  interviewerFinish(session: Session, finishParams: {
    resolutions: { 
      main: { name: string, resolution: string }
      extra: { [key: string]: string }
     }
  }): Observable<{session: Session}> 
  {
    const url = this.buildUrl(session.id, 'interviewer_finish')
    
    const body = JSON.stringify({
      finish_params: finishParams,
      session: SessionInterviewerFinishSerializer.serialize(session)
    })
    let searchParams = new URLSearchParams()
    searchParams.set("current_role", this.currentUser() ? this.currentUser().currentRole : "guest")
    
    return this.appHttp.patch(url, body, { search: searchParams})
      .map(resp => this.processResponse(resp))
      .map(resp => resp as {session: Session})
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/session.service.ts